

















































import { MetaVendedorService } from "@/services/meta-vendedor.service";
import { UsuariosService } from "@/services/usuarios.service";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Modal from "@/shared/components/modal.vue";
import { maiorQue, requiredValidZero, vetorVazio } from "@/shared/validators";
import { Component, Vue } from "vue-property-decorator";

interface UsuarioItem {
  idUsuario: number;
  nome: string;
}

@Component({
  components: {
    Modal,
    InputMoeda,
  },
})
export default class AdicionarMetasLote extends Vue {
  mesReferencia = "";
  idsUsuarios: number[] = [];
  qtdPontos: number | null = null;
  valorBonus: number | null = null;
  loading = false;
  usuariosVendedores: UsuarioItem[] = [];

  rules = {
    idsUsuarios: [vetorVazio()],
    qtdPontos: [requiredValidZero(), maiorQue(0)],
    valorBonus: [requiredValidZero()],
  };

  async abrir(mesReferencia: string) {
    this.mesReferencia = mesReferencia;
    this.idsUsuarios = [];
    this.qtdPontos = null;
    this.valorBonus = null;

    await this.carregarUsuariosVendedores();

    const modal = this.$refs.modal as Modal;
    return modal.open();
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  async salvar() {
    const form = this.$refs.form as any;
    if (!form?.validate()) {
      return;
    }

    this.loading = true;
    try {
      await MetaVendedorService.AdicionarMeta({
        idsUsuarios: this.idsUsuarios,
        mesReferencia: this.mesReferencia,
        qtdPontos: Number(this.qtdPontos),
        valorBonus: Number(this.valorBonus),
      });

      const modal = this.$refs.modal as Modal;
      modal.close(true);
    } finally {
      this.loading = false;
    }
  }

  async carregarUsuariosVendedores() {
    const response = await UsuariosService.Lista({
      role: "",
      txtPesquisa: "",
      ativo: true,
      offset: 0,
      limit: 1000,
      order: "nome",
    });

    const lista = Array.isArray(response) ? response : response?.lista || [];

    this.usuariosVendedores = lista.map((usuario: any) => ({
      idUsuario: Number(usuario.idUsuario),
      nome: usuario.nome,
    }));
  }
}
